var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkWrench(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "20px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A__53") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68463,79.11316a9.159,9.159,0,0,0,.1239,13.07831,9.159,9.159,0,0,0,13.07831.1239L55.47668,57.72552c6.41791-6.41784,9.4571-6.46093,15.01819-6.43945,6.55268.02161,11.9682-1.234,17.82569-7.09149a22.7915,22.7915,0,0,0,6.1-21.25287c-.23712-1.04541-1.09393-1.27716-1.8537-.51733L79.08435,35.9068a3.64335,3.64335,0,0,1-3.18463.85687l-7.95905-2.12854a3.468,3.468,0,0,1-1.55731-1.01849,3.468,3.468,0,0,1-1.01849-1.55731l-2.12854-7.95905a3.64335,3.64335,0,0,1,.85687-3.18463L77.57562,7.43317c.75983-.75977.52808-1.61658-.51733-1.8537a22.7915,22.7915,0,0,0-21.25287,6.1c-5.85748,5.85749-7.1131,11.273-7.09149,17.82569.02148,5.56109-.02161,8.60028-6.43945,15.01819Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkWrench);
export default __webpack_public_path__ + "static/media/work-wrench.1dc7a830c52a202419eecbcbfd8b1813.svg";
export { ForwardRef as ReactComponent };